import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dt-integration-form"
export default class extends Controller {
  static targets = [
    "buttonHandleUniqueKey",
    "uniqueKeyField",
    "encryptedField",
    "modalForm",
    "terminationFields",
    "terminationInput",
  ];
  static values = { successMessage: String };

  connect() {
    this.toggleActionType();
  }

  toggleActionType() {
    const selected = this.element.querySelector(
      'input[name="dt_record_integration[workflow_mode]"]:checked',
    );
    const isTermination = selected?.value === "termination";

    if (this.hasTerminationFieldsTarget) {
      this.terminationFieldsTarget.classList.toggle("d-none", !isTermination);
    }

    this.terminationInputTargets.forEach((input) => {
      input.disabled = !isTermination;
    });
  }

  toggleEditUniqueKey() {
    if (!this.hasButtonHandleUniqueKeyTarget || !this.hasUniqueKeyFieldTarget)
      return;

    // Cambiamos el parametro encrypted a false para que se pueda editar la clave
    // y para que el modelo detecte que debe encryptarla
    this.encryptedFieldTarget.value = 0;
    this.uniqueKeyFieldTarget.removeAttribute("readonly");
    this.uniqueKeyFieldTarget.value = "";
    this.uniqueKeyFieldTarget.focus();

    if (this.buttonHandleUniqueKeyTarget) {
      this.buttonHandleUniqueKeyTarget.setAttribute("readonly", true);
    }
  }

  handleSubmit(event) {
    if (!event.detail.success) return;

    const fetchResponse = event.detail.fetchResponse;

    if (!fetchResponse) return;

    if (this.hasModalFormTarget) {
      const myModal = bootstrap.Modal.getInstance(this.modalFormTarget);
      myModal.hide();
    }

    if (fetchResponse.redirected) {
      // Esta línea redirige al usuario a la URL proporcionada por fetchResponse.location.href,
      // usando Turbo y la acción 'advance', que reemplaza la página actual en el historial
      // sin crear una nueva entrada, simulando una navegación clásica pero optimizada.
      Turbo.visit(fetchResponse.location.href, { action: "advance" });
    }
  }
}
